/**
 * Кликабельная строка, из которой при этом МОЖНО ВЫДЕЛИТЬ ТЕКСТ.
 *
 * На экранах кабинета строка целиком открывает разворот или ставит отбор — это
 * привычно и правильно. Но человек приходит на экран сверки за ЧИСЛОМ: дату,
 * номер отчёта, сумму он хочет выделить и унести в переписку или в кабинет WB.
 *
 * Два препятствия, и они разные:
 *
 * 1. Строка, свёрстанная тегом `<button>`, не отдаёт своё содержимое под
 *    выделение вовсе — так ведут себя контролы формы во всех браузерах.
 *    Лечится только тегом: `<div role="button" tabIndex={0}>` плюс
 *    `onKeyDown` из `клавишаКнопки()`, чтобы клавиатура работала как у кнопки.
 * 2. Даже на `<div>` протяжка мышью заканчивается событием `click`, и строка
 *    разворачивалась бы ровно в тот момент, когда человек отпустил выделение.
 *    Лечится проверкой `выделяли()`.
 */

/** Человек только что тянул выделение — клик по строке трогать не должен. */
export function выделяли(): boolean {
  const selection = window.getSelection();
  // `isCollapsed` — схлопнутое (пустое) выделение, то есть обычный клик:
  // браузер схлопывает прежнее выделение уже на `mousedown`, поэтому «выделил
  // где-то раньше, потом кликнул сюда» сюда не попадает.
  return selection !== null && !selection.isCollapsed && selection.toString().trim() !== "";
}

/**
 * Клавиатура для `role="button"`: Enter и пробел, как у настоящей кнопки.
 * Пробел гасим `preventDefault()` — иначе он прокручивает страницу.
 */
export function клавишаКнопки(action: () => void) {
  return (event: React.KeyboardEvent) => {
    if (event.key !== "Enter" && event.key !== " ") return;
    event.preventDefault();
    action();
  };
}

/**
 * Клик по строке таблицы отмечает её — но не клик по ссылке, кнопке, флажку,
 * не протяжка выделения и не клик в панели, открытой из строки (порталом она
 * вне строки в документе, а событие React всплывает по дереву компонентов).
 */
export function кликСтроки(e: React.MouseEvent<HTMLElement>): boolean {
  const цель = e.target as Element;
  if (!e.currentTarget.contains(цель)) return false;
  if (цель.closest("a, button, input, [role=button]")) return false;
  return !выделяли();
}
